export const facetResultsMustMatch = [
    'allValues',
    'atLeastOneValue',
];
